"use client";

import { useProductQuickView } from "@faire/deprecated-retailer-visitor-shared/components/ProductQuickView/ProductQuickViewContext";
import { QuickViewProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickView/QuickViewProps";
import { useSettingEnableProductQuickView } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableProductQuickView";
import { IconButton } from "@faire/slate/components/icon-button";
import { Information } from "@faire/slate/icons/Information";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import React from "react";

import { useTileInteractions } from "./TileInteractionsContextProvider";

export const QuickView: React.FC<{ data: QuickViewProps }> = ({ data }) => {
  const context = useTileInteractions();
  const { setProductToken } = useProductQuickView();
  const { isDesktopAndAbove } = useViewport();
  const { isButtonVersion } = useSettingEnableProductQuickView();

  const handleClick = () => {
    context?.tileActions?.onProductClick?.(data.productToken ?? "");
    setProductToken?.(data.productToken);
  };

  if (isButtonVersion && setProductToken && isDesktopAndAbove) {
    return (
      <div className="absolute bottom-2 left-2">
        <IconButton
          size="xSmall"
          variant="secondary"
          Icon={Information}
          onClick={handleClick}
        />
      </div>
    );
  }

  return null;
};
